<template>
  <router-link class="menu-item" :to="{name: route.name, params: routeParams}"
               :class="{notActive:(route.name === 'IndexPage' && $route.name!='IndexPage')} ">
    <div class="item-label">{{ label }}</div>
  </router-link>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "MenuItem",
  props: {
    route: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    params:{
      type: Object,
    }
  },
  computed: {
    ...mapState({
      currentLanguage: state => state.currentLanguage.toLowerCase(),
      defaultLanguage: state => state.defaultLanguage.toLowerCase()
    }),
    routeParams() {
      return  {
        ...this.params,
        ...(this.currentLanguage !== this.defaultLanguage &&  {lang:this.currentLanguage})
      }

    }
  }
}
</script>

<style lang="scss">
@import "MenuItem";
</style>
